import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {DEFAULT_DISTANCE} from "../../../offer/list/constants/offer_list";
import {OfferType} from "../../../offer/types/OfferType";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;

const offerListConstrains = {
    limited_presentation: "False",
    display_type: [OfferDisplayType.FOR_SALE],
    for_sale: "True",
    show_on_listing: "True"
};

export const fetchOffersData = (regionId: number) => {
    const offerListMapOfferLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST_MAP);

    const fullQuery = {
        distance: DEFAULT_DISTANCE,
        region: regionId,
        type: OfferType.FLAT,
        ...offerListConstrains,
        page_size: OFFER_LIST_MAP_PAGE_SIZE
    };

    const url = appendQueryString(offerListMapOfferLink, fullQuery);

    return getRequest(clientRpRequestMeta, url);
};
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {DEFAULT_DISTANCE} from "../../../offer/list/constants/offer_list";
import {OfferType} from "../../../offer/types/OfferType";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;

const offerListConstrains = {
    limited_presentation: "False",
    display_type: [OfferDisplayType.FOR_SALE],
    for_sale: "True",
    show_on_listing: "True"
};

export const fetchOffersData = (regionId: number) => {
    const offerListMapOfferLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST_MAP);

    const fullQuery = {
        distance: DEFAULT_DISTANCE,
        region: regionId,
        type: OfferType.FLAT,
        ...offerListConstrains,
        page_size: OFFER_LIST_MAP_PAGE_SIZE
    };

    const url = appendQueryString(offerListMapOfferLink, fullQuery);

    return getRequest(clientRpRequestMeta, url);
};
